import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { AppState } from "../../store/root.reducer";
import { useAutoLogin } from "../../hooks/useAutoLogin";
import React from "react";
import { hasValidStoredAccessToken } from "../../utils/authToken";

export const PrivateRoutes = () => {
  const autoLogin = useAutoLogin();
  const { user, loading } = useSelector((state: AppState) => state.auth);
  const triedRef = React.useRef(false);
  const canBootstrapFromToken = !user && hasValidStoredAccessToken();

  React.useEffect(() => {
    if (user) {
      triedRef.current = false;
      return;
    }

    if (!triedRef.current) {
      triedRef.current = true;
      autoLogin(false);
    }
  }, [user, autoLogin]);

  if (!user && (loading || canBootstrapFromToken)) {
    return <div>Authenticating...</div>;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};
